import { GroupInventoryItem } from "../../models/User";
import { PowerUpItem } from "../../reducers/rush-game.reducer";
import { GemsIcon } from "../ui/gems-icon";
import ShieldPowerUpIcon from "../ui/shields-power-up-icon";

interface PowerUpItemsProps {
  code: string,
  quantity: number
}

export const PowerUpItems: React.FC<PowerUpItemsProps> = ({code, quantity}) => {
  return (
    <div className="w-[105px] medium-button-fire flex gap-2 center">
      <ShieldPowerUpIcon code={code}/>
      <p className="text-white text-xl grow">1 / {quantity}</p>
    </div>
  );
}

interface CTAPowerUpProps {
  code: string,
  quantity: number,
  isUsed: boolean,
  price: number,
  value: number,
}

export const CTAPowerUp: React.FC<CTAPowerUpProps> = ({code, quantity, isUsed, price, value}) => {
  return (
    <div className="medium-button-grey flex center justify-between w-full py-1.5">

      <div className="flex center gap-2">
        <ShieldPowerUpIcon code={code} size={32} quantity={quantity}/>
        <p>{value}% Loss reduction</p>
      </div>

      {/* START USE */}
      { quantity > 0 && !isUsed &&
        <span className="bg-gray-700 px-2 py-1.5 rounded text-xs text-white leading-[10px]">
          USE
        </span>
        }

      {/* STOP USE */}
      { quantity > 0 && isUsed &&
        <span className="bg-gray-700 px-2 py-1.5 rounded text-xs text-white leading-[10px]">
          REMOVE
        </span>
      }

      {/* BUY 1*/}
      { quantity == 0 &&
        <div className="flex center gap-1 p-1.5 bg-blue text-white text-xs rounded box-content w-[32px]">
          <GemsIcon h={14}/>
          {price}
        </div>
      }

    </div>
  );
}

interface CondensedPowerUpProps {
  powerUp: GroupInventoryItem
}

export const CondensedPowerUp: React.FC<CondensedPowerUpProps> = ({powerUp}) => {
  return (
    <div className="flat-card !py-0 !px-4 flex flex-col flex-1 center justify-center gap-1 !pb-1">
      <p className="text-xs text-gray-700 pt-1">
        Power-Ups
      </p>
      <PowerUpItems code={powerUp.code} quantity={powerUp.quantity}/>
    </div>
  );
}